module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    attrs: {
      "clearable": "",
      "multiple": "",
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.adminUserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname + ' - ' + item.phone))])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78ddcd85","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AdminUserMultSelect.vue
// module id = 1879
// module chunks = 8